import React, { useContext } from "react";
import { StateContext } from "../../../state/index";
import ConfigComponent from '../../ConfigComponent';
import Title from '../../library/Title';
import { TOKEN_TYPES } from "../../../utils/enums";
import { ButtonContainer } from "../../library/Buttons";
import Button from "../../library/Buttons";
import StartOver from "../../library/StartOver";
import { actions } from "../../../state";
import { get } from "lodash/object";

export const AddressAcceptView = ({children, onSubmit, isFetching}) => {
  const [{ payment, tokens, configuration }, dispatch] = useContext(StateContext);

  const { street_address_1, street_address_2, city, state, postal_code } = get(tokens, `${TOKEN_TYPES.RECIPIENT_LOGIN}.additional_data.user_data`, {});
  const { recipientFirstName, recipientLastName } = payment;

  return (
    <>
      <Title>
        <h1>Accept Payment</h1>
      </Title>
      <section className="main">
        <p className="description"><ConfigComponent config={configuration.acceptPayment.description} /></p>

        <div style={{padding: '1em', fontWeight: 'bold'}}>
          <div>{`${recipientFirstName} ${recipientLastName}`}</div>
          <div>{street_address_1}{street_address_2 && `, ${street_address_2}`}</div>
          <div>{`${city}, ${state} ${postal_code}`}</div>
        </div>

        {configuration.acceptPayment.secondaryText && <p className="description"><ConfigComponent config={configuration.acceptPayment.secondaryText} /></p>}
        <ButtonContainer
          horizontal
          style={{paddingBottom: 10}}
        >
          <Button
            onClick={() => dispatch(actions.tokens.setToken(TOKEN_TYPES.RECIPIENT_LOGIN, null))}
            label="Back"
            small
          />
          <Button
            onClick={onSubmit}
            label="Confirm"
            disabled={isFetching}
            small
            inverted
          />
        </ButtonContainer>
        <StartOver/>
      </section>
    </>
  );
};

export default AddressAcceptView;


